export default __webpack_public_path__ + "static/media/card-image-5.1b385137.jpg";